// Port of api/fuel/app/classes/filter/search/games/filters/query/play/date/first.php
export default {
	name: 'play.date.first',
	priority: 56,
	require: function(config, filter) {
		return filter.played && (
			(filter.played.first && (filter.played.first.from || filter.played.first.to)) ||
			(filter.played.sometime && (filter.played.sometime.from || filter.played.sometime.to) && filter.play && filter.play.first)
		)
	},
	run: function(config, filter, data, query) {
		if (filter.played.first.from) query.having('MIN(p.play_date)', '>=', filter.played.first.from)
		if (filter.played.first.to) query.having('MIN(p.play_date)', '<=', filter.played.first.to)
		if (filter.played.sometime.from) query.having('MIN(p.play_date)', '>=', filter.played.sometime.from)
		if (filter.played.sometime.to) query.having('MIN(p.play_date)', '<=', filter.played.sometime.to)
	}
}
